export const getDeviceLocationInfo = async (): Promise<string | null> => {
    let position: GeolocationPosition | null = null;

    // 1️⃣ Provo a prendere la posizione dal browser
    if (navigator.geolocation) {
        try {
            position = await new Promise<GeolocationPosition>((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, {
                    enableHighAccuracy: false,
                    timeout: 15000,
                    maximumAge: 600000
                });
            });
        } catch {
            position = null; // browser geolocation fallita
        }
    }

    // 2️⃣ Fallback IP se la posizione non è disponibile
    if (!position) {
        try {
            const ipResponse = await fetch('https://ipapi.co/json/');
            const ipData = await ipResponse.json();
            if (ipData.city && ipData.region) return `${ipData.city} ${ipData.region}`;
        } catch {
            return null;
        }
    }

    // 3️⃣ Reverse geocoding con più servizi
    const reverseGeocodeServices = [
        async () => { // Google Maps
            const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${position!.coords.latitude},${position!.coords.longitude}&language=it&result_type=locality|administrative_area_level_1&key=YOUR_API_KEY`);
            const data = await res.json();
            const result = data.results?.[0]?.address_components;
            if (result) {
                const city = result.find((c: any) => c.types.includes('locality'))?.long_name;
                const state = result.find((c: any) => c.types.includes('administrative_area_level_1'))?.long_name;
                if (city && state) return `${city} ${state}`;
            }
            return null;
        },
        async () => { // Nominatim OpenStreetMap
            const res = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${position!.coords.latitude}&lon=${position!.coords.longitude}&zoom=10&accept-language=it`);
            const data = await res.json();
            if (data.address?.city && data.address?.state) return `${data.address.city} ${data.address.state}`;
            return null;
        },
        async () => { // BigDataCloud
            const res = await fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${position!.coords.latitude}&longitude=${position!.coords.longitude}&localityLanguage=it`);
            const data = await res.json();
            if (data.city && data.principalSubdivision) return `${data.city} ${data.principalSubdivision}`;
            return null;
        }
    ];

    for (const service of reverseGeocodeServices) {
        try {
            const result = await service();
            if (result) return result;
        } catch {
            continue;
        }
    }

    return null;
};
